/* eslint-disable no-undef */
const pluginPath =
   (platformUI &&
      platformUI.config &&
      platformUI.config.pluginPaths &&
      platformUI.config.pluginPaths[process.env.PLUGIN_ID]) ||
   "";
const hasScheme = (path) =>
   path.indexOf("http") === 0 || path.indexOf("//") === 0;
__webpack_public_path__ = hasScheme(pluginPath)
   ? `${pluginPath}/app/${process.env.PLUGIN_ID}/`
   : `${pluginPath}/`;
